import type { Meta, StoryObj } from "@storybook/react";

import type { EventDetailsLinesProps } from "@/ui/components/schedule/details/EventDetailsLines";
import EventDetailsLines from "@/ui/components/schedule/details/EventDetailsLines";

const StoryMeta: Meta<EventDetailsLinesProps> = {
  title: "Components/Schedule/Event Details Lines",
  component: EventDetailsLines,
  argTypes: {
    dateRange: {
      control: {
        type: "text",
      },
    },
    isRecurring: {
      control: {
        type: "boolean",
      },
    },
    nextStartDate: {
      control: {
        type: "text",
      },
    },
    recurrenceString: {
      control: {
        type: "text",
      },
    },
    startDate: {
      control: {
        type: "text",
      },
    },
    timeRange: {
      control: {
        type: "text",
      },
    },
  },
  args: {
    dateRange: "Jul 1 - Dec 31, 2024",
    isRecurring: true,
    nextStartDate: "Tuesday, August 31",
    recurrenceString: "Every day",
    startDate: "Tuesday, June 30",
    timeRange: "9am - 9:30am",
  },
};

type Story = StoryObj<EventDetailsLinesProps>;

export const Primary: Story = {};
export default StoryMeta;
